import { ResourceCornSchema, TagSchema } from '../tag.js';
export const RemoveTagFromResourceBodyRequestSchema = TagSchema.pick({
    key: true,
    value: true,
}).partial({ value: true });
export const RemoveTagFromResourcePathRequestSchema = ResourceCornSchema;
export const RemoveTagFromResourceRequestSchema = RemoveTagFromResourceBodyRequestSchema.and(RemoveTagFromResourcePathRequestSchema);
export const RemoveTagFromResourceResponseSchema = TagSchema;
